import { APIError } from "@sieg-ad/fetch";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, vm, info) => {
    if (error instanceof CustomError || error instanceof AbortError || error instanceof APIError) {
      console.error(error.message);
    }
    else if (error instanceof CustomWarn) {
      console.warn(error.message);
    }
    else {
      // const err = error as Error;
      // console.error(err.message || err);
      console.error(error);
    }
  };
});